export const isIframed = (contextWindow: Window) => {
    try {
        return contextWindow.self !== contextWindow.top;
    } catch (error) {
        return true;
    }
};
